/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'redux';
import { AxiosResponse } from "axios";
import { 
    // MultiRecordResponse, 
    ThunkResult } from "./actionResultTypes";
import { 
    Action,
    ActionType, 
    IFetchReportVisits,
    IFetchReportVisitsSuccess,
    IFetchReportVisitsFail,
    IEditReportVisit,
    IEditReportVisitSuccess,
    IEditReportVisitFail,
} from "../actionTypes/reportVisitActionType";
import { 
    IRequestReportVisit,
    IReportVisit as ReportVisit, 
} from '../../models/reportVisit';
import { MultiResponseType } from '../../models/multiResponseType'
import { httpGenerator } from '../../services';


export const GetReportVisits = (contractid: number, dateid: number): ThunkResult<void> => async (dispatch: Dispatch<Action>) => { 
    dispatch<IFetchReportVisits>({  
        type: ActionType.FETCH_REPORTVISITS 
    });

    try {
        const authToken = sessionStorage.getItem("token")
        const response: AxiosResponse<MultiResponseType<ReportVisit>> = await httpGenerator(authToken!).get(`reportVisit/${contractid}/${dateid}/`);
        dispatch<IFetchReportVisitsSuccess>({
            type: ActionType.FETCH_REPORTVISITS_SUCCESS,
            payload: response.data
        });

    } catch(err: any) {
        dispatch<IFetchReportVisitsFail>({
            type: ActionType.FETCH_REPORTVISITS_FAIL,
            payload: err
        });
        console.log('err: ', err)
        // toastError("خطا در بازیابی اطلاعات");
    }
}

export const SetReportVisit = (request: IRequestReportVisit): ThunkResult<void> => async (dispatch: Dispatch<Action>) => { 
        dispatch<IEditReportVisit>({ 
            type: ActionType.EDIT_REPORTVISIT 
        });
        try {
            console.log('SetReportVisit Request: ', request)
            const authToken = sessionStorage.getItem("token")
            await httpGenerator(authToken!).post(`reportVisit/`, request);
            dispatch<IEditReportVisitSuccess>({ 
                type: ActionType.EDIT_REPORTVISIT_SUCCESS, 
            });
            // toastSuccess("اطلاعات مورد نظر با موفقیت ویرایش گردید");
    
        } catch (err: any) {
            dispatch<IEditReportVisitFail>({ 
                type: ActionType.EDIT_REPORTVISIT_FAIL,
                payload: err
            });
            console.log('err: ', err)
            // toastError("خطا در ویرایش اطلاعات مورد نظر");
        }
    };